module.exports = __webpack_public_path__ + "media/online_university/more-choices@2x-c6554b55.png";